<template>
  <modal name="carat-dialog"
    :adaptive="true"
    :scrollable="true"
    height="auto">
    <div class="v--modal-close-top" v-loading.fullscreen.lock="fullscreenLoading" v-if="nowStep==2 && fromMypage=='mypage'">
        <el-button @click="closeDialog"
        icon="el-icon-circle-close-outline"
        style="font-size: 2rem;"
        type="text"></el-button>
    </div>
    <div class="v--modal-close-top" v-loading.fullscreen.lock="fullscreenLoading" v-else-if="nowStep==2">
        <el-button @click="nowStep=1"
        icon="el-icon-back"
        style="font-size: 2rem;"
        type="text"></el-button>
    </div>
    <div class="v--modal-close-top" v-loading.fullscreen.lock="fullscreenLoading" v-else>
        <el-button @click="closeDialog"
          icon="el-icon-circle-close-outline"
          style="font-size: 2rem;"
          type="text"></el-button>
    </div>
    <div id="renew2_popup_joblist_carat" v-if="nowStep==91">
        <div class="popup_block">
            <div class="txt_block">
              <p class="txt01">ダウンロードが完了しました！！</p>
              <h3 class="txt02">あなたの履歴書から</h3>
              <h3 class="txt02">AIがオススメの好条件求人を紹介</h3>
              <h3 class="txt02">あなただけの特別リスト</h3>
              <h3 class="txt02">作成した履歴書で<br>好条件の勤め先に一緒に応募</h3>
              <p class="txt03">あなただけの限定求人</p>
            </div>
            
            <!--求人リスト-->
            <div class="popup_item">

                <div class="carat_block" v-for="(item, index) in job_list" v-if="!item.is_applicated">
                    <div class="carat_wrap">
                        <a  class="carat_link"><!--このaタグは詳細ページリンク-->
                            <div class="joblist_link">
                                <div class="joblist_link01" @click="clickCarat(item.id)">
                                  <p class="txt_category" v-for="(item2, index2) in item.employment_types">{{ item2 }}</p>
                                  <p class="txt_area">{{ item.work_location }}</p>
                                </div>
                                <div class="joblist_link02" @click="clickCarat(item.id)">
                                    <h4 class="joblist_h4">{{ item.title }}</h4>
                                    <p class="joblist_txt">{{ item.company_name }} {{ item.work_location }}</p>
                                    <p class="joblist_txt">{{ item.salary.slice(0, salarylength) }}</p>
                                </div>
                                <button type="button" id="send-carat-application"
                                    v-if="!item.is_applicated"
                                    @click="applicantCarat(item.id);item.is_applicated=true"
                                    class="el-button el-button--success carat_btn"><span
                                      >タップで応募完了！</span>
                                </button>
                                <button type="button" id="send-carat-application"
                                    v-else
                                    @click="applicantCarat(item.id)"
                                    class="el-button el-button--success carat_btn"><span
                                      >応募済み</span>
                                </button>
                            </div>
                        </a>
                    </div>
                    <a @click="clickCarat(item.id)" class="joblist_detail_link">この求人の詳細を見る&#9650;</a><!--このaタグは詳細ページリンク-->
                </div>

            </div>
            <div>
                <p>Yagishの<a href="https://rirekisho.yagish.jp/terms" target="_blank">利用規約</a>、<a href="https://www.yagish.jp/privacy/" target="_blank">個人情報保護方針</a></p>
                <p>Caratの<a href="https://glit.notion.site/Hub-68dbddef9e33469a9298f57f0f5b9e2a" target="_blank">プライバシーポリシー</a></p>
                <p><img src="/static/renew_img/check_icon.png" alt="同意する" style="height: 20px;">規約に同意して応募する</p>
            </div>
        </div>
    </div>
    <div id="renew2_popup_joblist_carat" v-if="nowStep==1">
        <div class="popup_block">
            <div class="txt_block" v-if="isTxtBlock">
              <p class="txt01">ダウンロードが完了しました！！</p>
              <h3 class="txt02" style="font-size: 1.1rem;">作成した履歴書で<br>好条件の勤め先に一緒に応募</h3>
              <p class="txt03">あなただけの限定求人</p>
            </div>
            <div class="txt_block" v-else>
              <p class="txt01">ダウンロードが完了しました！！</p>
              <h3 class="txt02" style="font-size: 1.1rem;">あなたの履歴書から<br>AIがオススメの好条件求人を紹介</h3>
              <p class="txt03">あなただけの特別リスト</p>
            </div>
            <!--求人リスト-->
            <div class="popup_item">

                <div class="carat_block" v-for="(item, index) in job_list" v-if="!item.is_applicated">
                    <div class="carat_wrap">
                        <a  class="carat_link"><!--このaタグは詳細ページリンク-->
                            <div class="joblist_link">
                                <div class="joblist_link01" @click="clickCarat(item.id)">
                                  <p class="txt_category" v-for="(item2, index2) in item.employment_types">{{ item2 }}</p>
                                  <p class="txt_area">{{ item.work_location }}</p>
                                </div>
                                <div class="joblist_link02" @click="clickCarat(item.id)">
                                    <h4 class="joblist_h4">{{ item.title }}</h4>
                                    <p class="joblist_txt">{{ item.company_name }} {{ item.work_location }}</p>
                                    <p class="joblist_txt">{{ item.salary.slice(0, salarylength) }}</p>
                                </div>
                                <button type="button"
                                    :id="'pdf-'+$globalVar.dn_flag+'-carat-completed'"
                                    v-if="!item.is_applicated"
                                    @click="applicantCarat(item.id);item.is_applicated=true"
                                    class="el-button el-button--success carat_btn"><span
                                      >履歴書を提出</span>
                                </button>
                                <button type="button" id="send-carat-application"
                                    v-else
                                    @click="applicantCarat(item.id)"
                                    class="el-button el-button--success carat_btn"><span
                                      >応募済み</span>
                                </button>
                            </div>
                        </a>
                    </div>
                    <a @click="clickCarat(item.id)" class="joblist_detail_link">この求人の詳細を見る&#9650;</a><!--このaタグは詳細ページリンク-->
                </div>

            </div>
            <div style="font-size: 0.8rem;">
                <p>Yagishの<a href="https://rirekisho.yagish.jp/terms" target="_blank">利用規約</a>、<a href="https://www.yagish.jp/privacy/" target="_blank">個人情報保護方針</a></p>
                <p>Caratの<a href="https://glit.notion.site/Hub-68dbddef9e33469a9298f57f0f5b9e2a" target="_blank">プライバシーポリシー</a></p>
                <p><img src="/static/renew_img/check_icon.png" alt="同意する" style="height: 20px;">規約に同意して問い合わせる</p>
            </div>
        </div>
    </div>
    <div id="renew2_popup_joblist_carat" v-if="nowStep==20240214">
        <div class="popup_block">
            <div class="txt_block" v-if="isTxtBlock">
              <p class="txt01">ダウンロードが完了しました！！</p>
              <h3 class="txt02" style="font-size: 1.1rem;">作成した履歴書で<br>好条件の勤め先に一緒に応募</h3>
              <p class="txt03">あなただけの限定求人</p>
            </div>
            <div class="txt_block" v-else>
              <p class="txt01">ダウンロードが完了しました！！</p>
              <h3 class="txt02" style="font-size: 1.1rem;">あなたの履歴書から<br>AIがオススメの好条件求人を紹介</h3>
              <p class="txt03">あなただけの特別リスト</p>
            </div>
            <!--求人リスト-->
            <div class="popup_item">

                <div class="carat_block" v-for="(item, index) in job_list" v-if="!item.is_applicated">
                    <div class="carat_wrap">
                        <a  class="carat_link"><!--このaタグは詳細ページリンク-->
                            <div class="joblist_link">
                                <div class="joblist_link01" @click="clickCarat(item.id)">
                                  <p class="txt_category" v-for="(item2, index2) in item.employment_types">{{ item2 }}</p>
                                  <p class="txt_area">{{ item.work_location }}</p>
                                </div>
                                <div class="joblist_link02" @click="clickCarat(item.id)">
                                    <h4 class="joblist_h4">{{ item.title }}</h4>
                                    <p class="joblist_txt">{{ item.company_name }} {{ item.work_location }}</p>
                                    <p class="joblist_txt">{{ item.salary.slice(0, salarylength) }}</p>
                                </div>
                                <button type="button" id="send-carat-application"
                                    v-if="!item.is_applicated"
                                    @click="applicantCarat(item.id);item.is_applicated=true"
                                    class="el-button el-button--success carat_btn"><span
                                      >履歴書を提出</span>
                                </button>
                                <button type="button" id="send-carat-application"
                                    v-else
                                    @click="applicantCarat(item.id)"
                                    class="el-button el-button--success carat_btn"><span
                                      >応募済み</span>
                                </button>
                            </div>
                        </a>
                    </div>
                    <a @click="clickCarat(item.id)" class="joblist_detail_link">この求人の詳細を見る&#9650;</a><!--このaタグは詳細ページリンク-->
                </div>

            </div>
            <div style="font-size: 0.8rem;">
                <p>Yagishの<a href="https://rirekisho.yagish.jp/terms" target="_blank">利用規約</a>、<a href="https://www.yagish.jp/privacy/" target="_blank">個人情報保護方針</a></p>
                <p>Caratの<a href="https://glit.notion.site/Hub-68dbddef9e33469a9298f57f0f5b9e2a" target="_blank">プライバシーポリシー</a></p>
                <p><img src="/static/renew_img/check_icon.png" alt="同意する" style="height: 20px;">規約に同意して問い合わせる</p>
            </div>
        </div>
    </div>

    <div id="renew2_popup_joblist_carat" v-if="nowStep==2">
        <div class="popup_block">
            <div class="txt_block" @click="closeDialog" v-if="isMypage && false">
                <p class="txt01" style="cursor: pointer;">&lt; 求人リストに戻る</p>
            </div>
            <div class="txt_block" @click="nowStep=1" v-else-if="false">
                <p class="txt01" style="cursor: pointer;">&lt; 求人リストに戻る</p>
            </div>
            
            <!--求人リスト-->
            <div class="popup_item">
                <div class="detail_block">
                    <p class="txt_category" v-for="(item2, index2) in jod_detail.employment_types">{{ item2 }}</p>
                    <h4 class="joblist_h4">{{ jod_detail.title }}</h4>
                    <div class="detail_list">
                      <h5>募集職種</h5>
                      <p>{{ jod_detail.job }}</p>

                      <h5>想定年収</h5>
                      <p><pre style="white-space: pre-wrap;">{{ jod_detail.salary }}</pre></p>

                      <h5>勤務地</h5>
                      <p v-if="false" v-for="(item2, index2) in jod_detail.prefectures">{{ item2 }}</p>
                      <p  style="overflow-wrap: break-word;">{{ jod_detail.work_location }}</p>
                      
                      <h5>仕事内容</h5>
                      <p><pre style="white-space: pre-wrap;">{{ jod_detail.description }}</pre></p>

                      <h5>応募条件、求められるスキル</h5>
                      <p><pre style="white-space: pre-wrap;">{{ jod_detail.skill }}</pre></p>
                    </div>
                    <div class="detail_list">
                      <h5>給与・賞与</h5>
                      <p style="overflow-wrap: break-word;">{{ jod_detail.salary }}</p>

                      <h5>勤務時間</h5>
                      <p style="overflow-wrap: break-word;">{{ jod_detail.working_hour }}</p>

                      <h5>待遇・福利厚生</h5>
                      <p style="overflow-wrap: break-word;">{{ jod_detail.welfare }}</p>

                      <h5>休日・休暇</h5>
                      <p style="overflow-wrap: break-word;">{{ jod_detail.holiday }}</p>
                    </div>
                    <div class="detail_list">
                      <h4>企業詳細</h4>
                      <h5>社名</h5>
                      <p style="overflow-wrap: break-word;">{{ jod_detail.company_name }}</p>

                      <h5>本社所在地</h5>
                      <p style="overflow-wrap: break-word;">{{ jod_detail.company_address }}</p>
                    </div>
                    <div class="detail_img">
                      <img v-for="(item, index) in jod_detail.cover_urls"  :src="item" alt="">
                    </div>
                </div>
            </div>
            <div>
                <button type="button" id="send-carat-detail-application"
                @click="applicantCarat(jod_detail.id, 'd');jod_detail.is_applicated=true"
                class="el-button el-button--success carat_btn02"><span
                  >履歴書を提出</span>
                </button>
                <p>Yagishの<a href="https://rirekisho.yagish.jp/terms" target="_blank">利用規約</a>、<a href="https://www.yagish.jp/privacy/" target="_blank">個人情報保護方針</a></p>
                <p>Caratの<a href="https://glit.notion.site/Hub-68dbddef9e33469a9298f57f0f5b9e2a" target="_blank">プライバシーポリシー</a></p>
                <p><img src="/static/renew_img/check_icon.png" alt="同意する" style="height: 20px;">規約に同意して問い合わせる</p>
            </div>
        </div>
    </div>

    <div id="renew2_popup_joblist_carat" v-if="nowStep==3">
        <div class="popup_block">
            <div class="txt_block">
                <p class="txt01">ダウンロードが完了しました！！</p>
            </div>
            
            <div class="popup_item">
                <div class="complete_block">
                    <p class="complete_txt">お問い合わせありがとうございました。<br>担当者から追って連絡があります。</p>
                </div>
                <!--求人リスト-->
                <div class="popup_item">
                    <p class="complete_txt">他のお仕事もチェック！</p>
                    <div class="carat_block" v-for="(item, index) in job_list" v-if="!item.is_applicated">
                        <a><!--このaタグは詳細ページリンク-->
                            <div class="joblist_link">
                                <div class="joblist_link01" @click="clickCarat(item.id)">
                                    <p class="txt_category" v-for="(item2, index2) in item.employment_types">{{ item2 }}</p>
                                    <p class="txt_area">{{ item.work_location }}</p>
                                </div>
                                <div class="joblist_link02" @click="clickCarat(item.id)">
                                    <h4 class="joblist_h4">
                                      {{ item.title }}</h4>
                                    <p class="joblist_txt">{{ item.company_name }} {{ item.work_location }}</p>
                                    <p class="joblist_txt" style="color: #e3165c;opacity: 1;font-weight: bold;">{{ item.salary.slice(0, 20) }}...</p>
                                </div>
                                <button type="button" 
                                    :id="'pdf-'+$globalVar.dn_flag+'-carat-completed'"
                                    @click="applicantCarat(item.id)"
                                    class="el-button el-button--success carat_btn"><span
                                      >履歴書を提出</span>
                                </button>
                            </div>
                        </a>
                        <a v-if="false" @click="clickCarat(item.id)" class="joblist_detail_link">この求人の詳細を見る&#9650;</a><!--このaタグは詳細ページリンク-->
                    </div>
                </div>
            </div>
            <div>
                <p>Yagishの<a href="https://rirekisho.yagish.jp/terms" target="_blank">利用規約</a>、<a href="https://www.yagish.jp/privacy/" target="_blank">個人情報保護方針</a></p>
                <p>Caratの<a href="https://glit.notion.site/Hub-68dbddef9e33469a9298f57f0f5b9e2a" target="_blank">プライバシーポリシー</a></p>
                <p><img src="/static/renew_img/check_icon.png" alt="同意する" style="height: 20px;">規約に同意して問い合わせる</p>
            </div>
        </div>
    </div>


    <div id="renew2_popup_joblist_carat" v-if="nowStep==12">
      <div class="popup_block">
        <div class="txt_block">
            <p class="txt01">ダウンロードが完了しました！！</p>
            <h3 class="txt02">作成した履歴書で<br>好条件の勤め先に一緒に応募</h3>
            <p class="txt03">あなただけの限定求人</p>
        </div>
          
        <!--求人リスト-->
        <div class="popup_item">
            <div class="carat_block" v-for="(item, index) in job_list">
                <a @click="clickCarat(item.id)"><!--このaタグは応募ボタンと同じ-->
                    <div class="joblist_link">
                        <div class="joblist_link01">
                            <p class="txt_category" v-for="(item2, index2) in item.employment_types">{{ item2 }}</p>
                            <p class="txt_salary">{{ item.salary }}</p>
                        </div>
                        <div class="joblist_link02">
                            <h4 class="joblist_h4">
                                {{ item.title }}</h4>
                            <p class="joblist_txt">{{ item.work_location }}</p>
                        </div>
                        <button type="button" id="send-mynabi-pdf"  
                        @click="applicantCarat(item.id)"
                            class="el-button el-button--success carat_btn"><span
                              >規約に同意して応募</span>
                        </button>
                    </div>
                </a>
                <a @click="clickCarat(item.id)" class="joblist_detail_link">この求人の詳細を見る&#9650;</a><!--このaタグは詳細ページリンク-->
            </div>
        </div>

        <div>
            <p>Yagishの<a href="https://rirekisho.yagish.jp/terms" target="_blank">利用規約</a>、<a href="https://www.yagish.jp/privacy/" target="_blank">個人情報保護方針</a></p>
            <p>Caratの<a href="https://glit.notion.site/Hub-68dbddef9e33469a9298f57f0f5b9e2a" target="_blank">プライバシーポリシー</a></p>
        </div>
      </div>
    </div>
    <div id="renew2_popup_joblist_carat" v-if="nowStep==22">
      <div class="popup_block">
          <div class="txt_block" @click="closeDialog" v-if="isMypage">
              <p class="txt01" style="cursor: pointer;">&lt; 求人リストに戻る</p>
          </div>
          <div class="txt_block" @click="nowStep=1" v-else>
              <p class="txt01" style="cursor: pointer;">&lt; 求人リストに戻る</p>
          </div>
          
          <!--求人リスト-->
          <div class="popup_item">
              <div class="detail_block">
                  <p class="txt_category">業務委託</p>
                  <h4 class="joblist_h4">{{ jod_detail.title }}</h4>
                  <div class="detail_list">
                      <h5>募集職種</h5>
                      <p>{{ jod_detail.job }}</p>

                      <h5>想定年収</h5>
                      <p>{{ jod_detail.salary }}</p>

                      <h5>勤務地</h5>
                      <p v-for="(item2, index2) in jod_detail.prefectures">{{ item2 }}</p>

                      <h5>仕事内容</h5>
                      <p><pre>{{ jod_detail.description }}</pre></p>

                      <h5>応募条件、求められるスキル</h5>
                      <p><pre>{{ jod_detail.skill }}</pre></p>
                  </div>
                  <div class="detail_list">

                      <h5>給与・賞与</h5>
                      <p>{{ jod_detail.min_salary }}</p>

                      <h5>勤務時間</h5>
                      <p>{{ jod_detail.working_hour }}</p>

                      <h5>待遇・福利厚生</h5>
                      <p>{{ jod_detail.welfare }}</p>

                      <h5>休日・休暇</h5>
                      <p>{{ jod_detail.holiday }}</p>
                  </div>
                  <div class="detail_list">
                      <h4>企業詳細</h4>
                      <h5>社名</h5>
                      <p>{{ jod_detail.company_name }}</p>

                      <h5>本社所在地</h5>
                      <p>{{ jod_detail.company_address }}</p>
                  </div>
                  <div class="detail_img">
                      <img v-for="(item, index) in jod_detail.cover_urls"  :src="item" alt="">
                  </div>
              </div>
          </div>
          <div>
              <button type="button" id="send-mynabi-pdf" @click="applicantCarat(jod_detail.id)"
              class="el-button el-button--success carat_btn02" ><span
                >規約に同意して応募</span>
              </button>
              <p>Yagishの<a href="https://rirekisho.yagish.jp/terms">利用規約</a>、<a href="https://www.yagish.jp/privacy/">個人情報保護方針</a></p>
              <p>Caratの<a href="https://glit.notion.site/Hub-68dbddef9e33469a9298f57f0f5b9e2a">プライバシーポリシー</a></p>
          </div>
      </div>
    </div>
    <div id="renew2_popup_joblist_carat" v-if="nowStep==31">
      <div class="popup_block">
        <div class="txt_block">
            <p class="txt01">ダウンロードが完了しました！！</p>
        </div>
        
        <!--求人リスト-->
        <div class="popup_item">
            <div class="complete_block">
                <p class="complete_txt">ご応募ありがとうございました。</p>
            </div>
        </div>
        <div>
            <p>Yagishの<a href="https://rirekisho.yagish.jp/terms">利用規約</a>、<a href="https://www.yagish.jp/privacy/">個人情報保護方針</a></p>
            <p>Caratの<a href="https://glit.notion.site/Hub-68dbddef9e33469a9298f57f0f5b9e2a">プライバシーポリシー</a></p>
        </div>
      </div>
    </div>
  
  </modal>
</template>
    

<style scoped>
    #renew2_popup_joblist_carat .popup_block{
        text-align: center;
        position: relative;
        /* top: -40px; */
        z-index: 1;
    }
    #renew2_popup_joblist_carat .popup_block .txt_block .txt02{
        font-size: 1.2rem;
        line-height: 1.5;
        margin-top: 10px;
    }
    #renew2_popup_joblist_carat .popup_block .txt_block .txt03{
        border-bottom: 3px solid #FFF620;
        /* background: #fff620; */
        display: inline-block;
    }
    #renew2_popup_joblist_carat .popup_block .popup_item{
        /* background: #eef5e8; */
        background: #eef5e8;
        padding: 0px 20px 20px 20px;
        width: calc(100% + 80px);
        margin: 0px -40px;
        height: 65vh;
        overflow: scroll;
        margin-top: 10px;
    }
    #renew2_popup_joblist_carat .popup_block .popup_item .carat_block{
        margin-top: 10px;
    }
    #renew2_popup_joblist_carat .popup_block .popup_item .carat_block:first-child{
        margin-top: 0;
    }
    #renew2_popup_joblist_carat .popup_block .popup_item .joblist_link{
        /* background: #fff; */
        background: #fff;
        padding: 10px 20px;
        margin: 10px 20px;
        border-radius: 8px;
    }
    #renew2_popup_joblist_carat .popup_block .popup_item .joblist_link .joblist_link01{
        display: flex;
        align-items: center;
    }
    #renew2_popup_joblist_carat .popup_block .popup_item .joblist_link .joblist_link01 .txt_category{
        background: rgb(15, 153, 52);
        color: rgb(255, 255, 255);
        border-radius: 50px;
        padding: 2px 10px;
        margin-right: 5px;
        font-size: 0.5rem;
        flex-wrap: wrap;
    }
    #renew2_popup_joblist_carat .popup_block .popup_item .joblist_link .joblist_link01 .txt_salary{
        flex-wrap: wrap;
    }
    #renew2_popup_joblist_carat .popup_block .popup_item .joblist_link .joblist_link02 .joblist_h4{
        color: #004d40;
        padding: 5px 0;
        line-height: 1.4;
        font-size: .9rem;
        text-align: left;
    }
    #renew2_popup_joblist_carat .popup_block .popup_item .joblist_link .joblist_link02 .joblist_txt{
        opacity: .5;
        font-size: .8rem;
        text-align: left;
    }
    #renew2_popup_joblist_carat .popup_block .popup_item .joblist_link .carat_btn{
        background-color: #E3165C;
        border-color: #E3165C;
        margin-top: 10px;
        width: 100%;
    }
    #renew2_popup_joblist_carat .popup_block .popup_item .joblist_detail_link{
        font-size: 0.8rem;
    }
</style>

<style scoped>
    #renew2_popup_joblist_carat .popup_block .popup_item .detail_block{
        padding-right: 20px;
        padding-left: 20px;
        text-align: left;
    }
    #renew2_popup_joblist_carat .popup_block .popup_item .detail_block .txt_category{
        display: inline-block;
        background: rgb(15, 153, 52);
        color: rgb(255, 255, 255);
        border-radius: 50px;
        padding: 2px 10px;
        margin-right: 5px;
        font-size: 0.5rem;
    }
    #renew2_popup_joblist_carat .popup_block .popup_item .detail_block .joblist_h4{
        padding: 5px 0 0;
        font-size: 1rem;
        color: #004d40;
    }
    #renew2_popup_joblist_carat .popup_block .popup_item .detail_block .detail_list{
        border-top: 1px solid #DFDFDF;
        padding-top: 20px;
        margin-top: 20px;
    }
    #renew2_popup_joblist_carat .popup_block .popup_item .detail_block .detail_img{
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        padding-top: 20px;
    }
    #renew2_popup_joblist_carat .popup_block .popup_item .detail_block .detail_img img{
        width: calc( 100% / 2 );
        object-fit: cover;
        height: 120px;
    }
    #renew2_popup_joblist_carat .popup_block .popup_item .detail_block .detail_list h5{
        margin-top: 10px;
    }
    #renew2_popup_joblist_carat .popup_block .popup_item .detail_block .detail_list h5:first-child{
        margin-top: 0;
    }
    #renew2_popup_joblist_carat .popup_block .carat_btn02{
        background-color: #E3165C;
        border-color: #E3165C;
        margin: 10px auto;
        width: 100%;
    }
    
</style>

<style scoped>
    #renew2_popup_joblist_carat .popup_block .popup_item .complete_block{
        padding-top: 50px;
    }

    #renew2_popup_joblist_carat .popup_block .popup_item .complete_txt{
        margin-bottom: 10px;
        font-size: 1rem;
        font-weight: bold;
    }
    .v--modal-box.v--modal {
        padding: 20px;
    }
    .v--modal-close-top{
      position: relative;
      z-index: 5;
    }
</style>

<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>
<script>
import _ from '@/assets/lib/my-lodash'
export default {
  components: {
  },
  data: function () {
    return {
      clearLocalStorageConfirmVisible: false,
      currentFormat: {},
      formatid: '',
      keyword: '',
      area: '',
      previewHtml: '',
      permissionType: 1,
      isSended:false,
      fullscreenLoading:false,
      username:'',
      baite_title:'バイト',
      age:0,
      isAgree:true,
      salarylength:200,
      job_list:[],
      nowStep:1,
      jod_detail:[],
      search_id:'',
      isMypage:false,
      fromMypage:'',
      isTxtBlock: true,
      submitBtnLabel:'タップで応募完了！',
      submitBtnLabels:[
        "タップで応募完了",
        "タップで簡単応募",
        "履歴書を送る",
        "作成した履歴書でアピール",
        "自分の履歴書でアピール"
      ]
    }
  },
  created : function(){
    const app = this
    this.$iterateStorage(function (value, key, iterationNumber) {
        //console.log all the kay/value pairs
        if (key === 'basicData') {
          app.username = value.lastName + '_' + value.firstName
        }
    }, function (err) {
        if (!err) {
            console.log('Iteration has completed');
        }
    })
  },
  computed: {
    cleanedPreviewHtml: function () {
      // PDFで文字化けするやつを変換しておく
      return this.previewHtml
    },
    pdfFormData: function () {
      const formData = new FormData()
      formData.append('app_html', this.cleanedPreviewHtml)
      formData.append('pdf_option', 'A4')
      return formData
    }
  },
  methods: {
    openCaratDialog: async function (id, html, keyword, address, age, nowStep = 1, job_id = null, search_id = null) {
      console.error('Carat openDialog' + nowStep)
      this.$modal.show('carat-dialog')
      this.formatid = id
      // this.previewHtml = html.$el.innerHTML
      this.clearLocalStorageConfirmVisible = false
      this.keyword = keyword
      this.area = address
      this.age = age
      this.nowStep = nowStep
      this.search_id = search_id
      this.fromMypage = id
      console.error(this.fromMypage)
      const nowdate = new Date()
      const date1 = new Date('2023/11/29 00:00:00')
      // const date2 = new Date('2023/10/26 02:00:00')
      /*日時の差をミリ秒単位で取得*/
      let diffMilliSec = nowdate - date1
      /*ミリ秒を日数に変換*/
      let diffDays = parseInt(diffMilliSec / 1000 / 60 / 60 / 24)
      console.error(diffDays)
      if (diffMilliSec < 0) {
        console.error(this.submitBtnLabels[diffDays])

      } else if (diffDays > 5) {
        let _idx = diffDays % 5 
        this.submitBtnLabel=this.submitBtnLabels[_idx]

      } else {
        this.submitBtnLabel=this.submitBtnLabels[diffDays]
      }
      if (diffDays % 3 == 2) {
        this.salarylength = 50
      } else if (diffDays % 3 == 1) {
        this.salarylength = 100
      } else {
        this.salarylength = 150
      }
      this.salarylength = 50
      if (parseInt(diffDays/5)%2 == 1) {
        this.isTxtBlock = false

      } else {
        this.isTxtBlock = true
      }
      this.isTxtBlock = true



      const formData = new FormData()
      // const formData = this.pdfFormData
      formData.append('uuid', this.$firebase.user.uid)
      const BACKUP_KEYS_LIST = [
        'format_rirekisho',
        'format_shokumukeirekisho',
        'basicData',
        'recentEdit'
      ]
      let storageData = {}
      await this.$iterateStorage(
        function (value, key, iterationNumber) {
          if (_.includes(BACKUP_KEYS_LIST, key)) {
            storageData[key] = value
          }
        },
        function (err) {
          if (err) {
            console.error(err)
          }
        }
      )
      console.error(storageData)
      formData.append('storage_data', JSON.stringify(storageData))
      formData.append('format_id', this.formatid)
      formData.append('dialog_name', 'carat_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('site_flag', 'r')
      formData.append('app_flag', this.$site.appFlag)
      const app = this
      this.$axios.post(this.$varuna.endPoints.displayDialog, formData, {timeout: 60000})
      this.$iterateStorage(function (value, key, iterationNumber) {
          //console.log all the kay/value pairs
          if (key === 'basicData') {
            app.username = value.lastName + '_' + value.firstName
          }
      }, function (err) {
          if (!err) {
              console.log('Iteration has completed');
          }
      })

      if (this.nowStep == 1) {

        // if (this.age >= 50 && this.age <= 59 && keyword == '') {
        //   formData.append('keyword', '50代')
        // }  else {
        //   formData.append('keyword', keyword)
        // }
        if (keyword == '') {
          formData.append('keyword', '未経験')
        }  else {
          formData.append('keyword', keyword)
        }
        if (this.formatid == "rerekisho_part_time" || this.formatid == "rirekisho_part_time2") {
          formData.append('keyword', '高時給')
        }
        formData.append('area', address)
        if (this.formatid == "rerekisho_part_time") {
          formData.append('occupation', 'アルバイト')
        } else if (this.formatid == "rirekisho_part_time2") {
          formData.append('occupation', 'パート')
        } else if (this.formatid == "rirekisho_job_new" ||  
          this.formatid == "rirekisho_job_new_single" ||  
          this.formatid == "internship") {
          formData.append('occupation', '正社員')
        } else {
          formData.append('occupation', '正社員')
        }
        this.fullscreenLoading=true

        this.$axios
          .post(this.$varuna.endPoints.getCaratList, formData, {timeout: 60000})
          .then(function (response) {
            app.$modal.show('carat-dialog')
            app.job_list = response.data.offers
            app.search_id = response.data.search_id
            app.keyword = response.data.keyword
            console.error(response)
            app.fullscreenLoading=false
            app.$message({
              duration: 0,
              showClose: true,
              dangerouslyUseHTMLString: true,
              message: `あなたにピッタリの求人リストを取得しました`,
              type: 'info'
            })
          })
          .catch(function (error) {
            app.$message({
              message: '求人リスト取得に失敗しました',
              type: 'error'
            })
          }).finally(function () {
          })
      } else if (nowStep == 2) {
        this.isMypage = true
        this.clickCarat(job_id, this.search_id)

      }


      
    },
    closeDialog: function () {
      this.$modal.hide('carat-dialog')
      this.clearLocalStorageConfirmVisible = false
      //this.$router.push('/mypage')
    },
    confirmWin: function () {
      confirm('応募するデータを送信します。よろしいでしょうか。')
    },
    clearLocalStorage: function () {
      this.$clearStorage()
      window.location = '/'
    },
    createFilename: function (ext) {
      const now = new Date()
      const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX
      const dateString = this.$formLib.dateFormat(now, '_yyyy-mm-dd_HH-MM-ss')
      return `${prefix}${this.formatid}${dateString}.${ext}`
    },
    sendCaratConsult: async function () {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      if (!this.isAgree) {
        this.$message({
          message: 'チェックしてから同意ボタンを押してください。',
          type: 'error'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = new FormData()
      // const formData = this.pdfFormData
      console.log(accessToken)
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('yaginame', this.username)
      formData.append('app_flag', this.$site.appFlag)
      formData.append('dialog_name', 'carat_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('version', '2')
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('reqflg', '2')
      console.log(this.$firebase.config.apiKey)
      console.log(accessToken)
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.caratPdfMail, formData, {timeout: 60000})
        .then(function (response) {
          app.isSended = true
          app.$message({
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `担当者からあなたに電話・メールでご連絡することがあります！`,
            type: 'error'
          })
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          console.error(error)
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    applicantCarat: async function (jobid, detail_flag = '') {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      this.isSended = true
      this.fullscreenLoading = true
      const formData = new FormData()
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('job_id', jobid)
      formData.append('format_id', this.formatid)
      formData.append('search_id', this.search_id)
      formData.append('yaginame', this.username)
      formData.append('detail_flag', detail_flag)
      formData.append('app_flag', this.$site.appFlag)
      formData.append('dialog_name', 'carat_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('version', '2')
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      if (this.age >= 50 && this.age <= 59) {
        formData.append('keyword', '50代')
      }  else {
        formData.append('keyword', this.keyword)
      }
      formData.append('area', this.area)

      if (this.formatid == "rerekisho_part_time") {
        formData.append('occupation', 'アルバイト')
      } else if (this.formatid == "rirekisho_part_time2") {
        formData.append('occupation', 'パート')
      } else if (this.formatid == "rirekisho_job_new" ||  
        this.formatid == "rirekisho_job_new_single" ||  
        this.formatid == "internship") {
        formData.append('occupation', '大学生')
      } else {
        formData.append('occupation', '正社員')
      }
      
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.applicationCarat, formData, {timeout: 60000})
        .then(function (response) {
          app.nowStep = 3
          app.isSended = false
          for (var _key in app.job_list) {
            if (app.job_list[_key].id==jobid) {
              app.job_list[_key].is_applicated = true
            }
          }
        })
        .catch(function (error) {
          app.$message({
            message: '応募失敗しました。',
            type: 'error'
          })
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    clickCarat: async function (id) {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      
      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)

      formData.append('job_id', id)
      formData.append('search_id', this.search_id)
      formData.append('format_id', this.formatid)

      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('site_flag', 'r')
      formData.append('app_flag', this.$site.appFlag)

      const app = this
      this.$axios
        .post(this.$varuna.endPoints.getCaratDetail, formData, {timeout: 60000})
        .then(function (response) {
          app.nowStep = 2
          console.error(response)
          app.jod_detail = response.data.offer
          
        })
        .catch(function (error) {
          app.$message({
            message: '求人詳細取得に失敗しました',
            type: 'error'
          })
        }).finally(function () {
        })
    }
  },
  beforeMount: function () {
    this.$eventHub.$on('send-carat-consult', this.sendCaratConsult)
    this.$eventHub.$on('send-carat-scout', this.sendCaratScout)
    this.$eventHub.$on('open-carat-dialog', this.openCaratDialog)
    this.$eventHub.$on('popstate', this.closeDialog)
  },
  destroyed: function () {
    this.$eventHub.$off('send-carat-consult', this.sendCaratConsult)
    this.$eventHub.$off('send-carat-scout', this.sendCaratScout)
    this.$eventHub.$off('open-carat-dialog', this.openCaratDialog)
    this.$eventHub.$off('popstate', this.closeDialog)
  }
}
</script>
